import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteInafectoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='INAFECTO' htmlFor='input-importeInafecto' md={6} alignRightAt='md' />
      <Col md={6}>
        <Form.InputNumber id='input-importeInafecto' name='input-importeInafecto' value={iValue} disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteInafectoFormGroup)
